/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getFairDeliverUpload = params => {
  return axios.post(`${base}/excel/query_upload`, params)
}

export const downFairSourceFile = id => {
  window.location.href = `${base}/excel/down_sourc_file_` + id
}

export const downFairErrorFile = id => {
  window.location.href = `${base}/excel/down_error_file_` + id
}

export const editRewardLogistics = params => {
  return axios.post(`${base}/edit_reward_deliver_` + params.id, params)
}
export const uploadFairFile = params => {
  return axios.post(`${base}/batch_add_fair_deliver`, params)
}



// WEBPACK FOOTER //
// ./src/views/fair-upload/fairUpload.api.js